import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { type DocumentDto, getDocuments } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useDocuments(): UseQueryResult<DocumentDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.documents(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getDocuments({ signal }).then((result) => result.data),
    });
}
